export default __webpack_public_path__ + "sharp-sans-bold-subset-602b722bd33f068c48dd581781addbf6.bundle.woff";